import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SupportedLang} from '@/app/core/models/supportedLang';

@Injectable({
	providedIn: 'root'
})
export class TranslateDynamicService {

	constructor(
		private readonly translateService: TranslateService,
	) {}

	getLang(): SupportedLang {
		return this.translateService.currentLang as SupportedLang;
	}
}
